
import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";


const CancellationRefundPolicy = () => {
  const navigate = useNavigate();
  return(

<div className="font-satoshi max-w-4xl mx-auto px-6 py-14 text-gray-800">
  <h1 className="text-3xl font-bold mb-6 text-center">Cancellation and Refund Policy – ClaimPro Assist</h1>
  <p className="text-base text-center mb-8 text-gray-600">Effective Date: 10/07/2025</p>

  <p className="mb-6 text-base">
    Thank you for choosing ClaimPro Assist. We are committed to providing a seamless and transparent service experience. This Cancellation and Refund Policy outlines the terms under which users can request cancellations and refunds for payments made through our website and mobile application.
  </p>

  <section className="mb-6">
    <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">1. Services Covered</h2>
    <ul className="list-disc pl-6 space-y-1 text-base">
      <li>Accident Claim Support Services</li>
      <li>On-road Assistance Services</li>
      <li>Document Processing or Consultancy Services</li>
      <li>Any other paid services offered via the platform</li>
    </ul>
  </section>

  <section className="mb-6">
    <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">2. Cancellation Policy</h2>
    <ul className="list-disc pl-6 space-y-1 text-base">
      <li>Once a service request has been successfully submitted and payment processed, it cannot be cancelled if the service has already been initiated.</li>
      <li>If the user cancels before the service is initiated or assigned, they may be eligible for a partial refund after deducting applicable service/processing charges.</li>
      <li>Cancellation requests must be sent to <a href="mailto:info@claimpro.in" className="text-[#21A6E9] underline">info@claimpro.in</a> within 2 hours of payment, along with the transaction details and reason for cancellation.</li>
    </ul>
  </section>

  <section className="mb-6">
    <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">3. Refund Policy</h2>
    <ul className="list-disc pl-6 space-y-1 text-base">
      <li>Refunds are only applicable if:
        <ul className="list-disc pl-6 mt-1 space-y-1">
          <li>The service could not be rendered due to internal issues or unavailability.</li>
          <li>A duplicate payment was made.</li>
          <li>A genuine service failure is determined after investigation.</li>
        </ul>
      </li>
      <li>No refunds will be processed for:
        <ul className="list-disc pl-6 mt-1 space-y-1">
          <li>Services that have been rendered or are in progress.</li>
          <li>User-initiated cancellations after service allocation.</li>
          <li>Claims made beyond 48 hours of payment.</li>
        </ul>
      </li>
      <li>Refunds, if approved, will be processed to the original payment method within 7-10 business days.</li>
    </ul>
  </section>

  <section className="mb-6">
    <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">4. How to Request a Refund</h2>
    <p className="text-base mb-2">To request a refund, please email us at <a href="mailto:info@claimpro.in" className="text-[#21A6E9] underline">info@claimpro.in</a> with the following:</p>
    <ul className="list-disc pl-6 space-y-1 text-base">
      <li>Full Name</li>
      <li>Registered Mobile Number</li>
      <li>Transaction ID</li>
      <li>Reason for Refund</li>
      <li>Any relevant supporting documents or screenshots</li>
    </ul>
  </section>

  <section className="mb-6">
    <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">5. Disputes & Grievances</h2>
    <p className="text-base mb-2">If you are not satisfied with the resolution, you may escalate the issue to our Grievance Officer:</p>
    <div className="text-base space-y-1">
      <p><strong>Grievance Officer</strong></p>
      <p>ClaimPro Assist Pvt. Ltd.</p>
      <p>Email: <a href="mailto:cs.yadav@claimpro.in" className="text-[#21A6E9] underline">cs.yadav@claimpro.in</a></p>
      <p>Phone: 7800784700</p>
    </div>
  </section>

  <section className="mb-6">
    <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">6. Policy Changes</h2>
    <p className="text-base">
      ClaimPro Assist reserves the right to update or modify this policy at any time. Any changes will be reflected on this page with a new effective date.
    </p>
  </section>
</div>
)}
export default CancellationRefundPolicy;

